import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Sidebar } from 'components';

import findKeyByValue from 'utils/common/findKeyByValue';

import useSidebarOptions from './hooks/useSidebarOptions';

import { ISidebarLayoutProps } from './SidebarLayout.types';

import { userNavigationMapping } from './constants/userNavigationMapping';

import './SidebarLayout.styles.scss';

const SidebarLayout = ({ children, ...props }: ISidebarLayoutProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const menuItems = useSidebarOptions();

  const activeMenuItem = location.pathname;

  const defaultOpenedKeys = useMemo(() => findKeyByValue(userNavigationMapping, activeMenuItem), [activeMenuItem]);

  const onMenuClick = item => {
    navigate(item.item.props.link);
  };

  return (
    <div className="np-sidebar-layout">
      <div className="np-sidebar-layout__menu">
        <Sidebar
          active={activeMenuItem}
          menuProps={{ items: menuItems, defaultOpenKeys: [defaultOpenedKeys], onClick: onMenuClick, ...props }}
        />
      </div>

      <div className="np-sidebar-layout__content">{children}</div>
    </div>
  );
};

export default SidebarLayout;
